import { useState } from 'react';
import UserManagementTable from '../../components/admin/UserManagementTable';
import FailedLoginsTable from '../../components/admin/FailedLoginsTable';
import AuditLogTable from '../../components/admin/AuditLogTable';
import CategoryStatsTable from '../../components/admin/CategoryStatsTable';

export default function AdminDashboard() {
  const [activeTab, setActiveTab] = useState('users');

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-3xl font-bold text-gray-900 mb-6">Pannello Amministrazione</h1>

        {/* Tabs */}
        <div className="bg-white rounded-lg shadow mb-6">
          <div className="border-b border-gray-200">
            <nav className="flex -mb-px">
              <button
                onClick={() => setActiveTab('users')}
                className={`px-6 py-3 text-sm font-medium border-b-2 ${
                  activeTab === 'users'
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-600 hover:text-gray-800 hover:border-gray-300'
                }`}
              >
                Gestione Utenti
              </button>
              <button
                onClick={() => setActiveTab('audit-log')}
                className={`px-6 py-3 text-sm font-medium border-b-2 ${
                  activeTab === 'audit-log'
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-600 hover:text-gray-800 hover:border-gray-300'
                }`}
              >
                Log Audit
              </button>
              <button
                onClick={() => setActiveTab('failed-logins')}
                className={`px-6 py-3 text-sm font-medium border-b-2 ${
                  activeTab === 'failed-logins'
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-600 hover:text-gray-800 hover:border-gray-300'
                }`}
              >
                Login Falliti
              </button>
              <button
                onClick={() => setActiveTab('statistics')}
                className={`px-6 py-3 text-sm font-medium border-b-2 ${
                  activeTab === 'statistics'
                    ? 'border-blue-600 text-blue-600'
                    : 'border-transparent text-gray-600 hover:text-gray-800 hover:border-gray-300'
                }`}
              >
                Statistiche
              </button>
            </nav>
          </div>
        </div>

        {/* Tab Content */}
        <div>
          {activeTab === 'users' && <UserManagementTable />}
          {activeTab === 'audit-log' && <AuditLogTable />}
          {activeTab === 'failed-logins' && <FailedLoginsTable />}
          {activeTab === 'statistics' && <CategoryStatsTable />}
        </div>
      </div>
    </div>
  );
}
